const DISCORD_CLIENT_ID = process.env.REACT_APP_DISCORD_CLIENT_ID;
const DISCORD_SCOPES = ['identify'];
const DISCORD_API = 'https://discordapp.com/api';

const getRedirectUri = () => {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
  return hostname === 'localhost' 
    ? 'http://localhost:3000/auth/discord/callback'
    : 'https://hsflrbx.com/auth/discord/callback';
};

export const discordAuth = {
  getAuthorizationUrl: () => {
    const redirectUri = getRedirectUri();
    const params = new URLSearchParams({
      client_id: DISCORD_CLIENT_ID,
      redirect_uri: redirectUri,
      response_type: 'code',
      scope: DISCORD_SCOPES.join(' '),
      state: generateState()
    });
    return `https://discord.com/oauth2/authorize?${params}`;
  },

  exchangeCodeForToken: async (code) => {
    try {
      const { supabase } = await import('./supabase.js');
      const redirectUri = getRedirectUri();
      
      const { data, error } = await supabase.functions.invoke('discord-auth', {
        body: { code, redirect_uri: redirectUri }
      });

      if (error || !data) {
        throw new Error(error?.message || 'Failed to exchange code');
      }

      return data;
    } catch (err) {
      console.error('Error exchanging Discord code:', err);
      throw err;
    }
  },

  getUser: async (accessToken) => {
    try {
      const response = await fetch(`${DISCORD_API}/users/@me`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      
      if (!response.ok) throw new Error('Failed to fetch user');
      return await response.json();
    } catch (err) {
      console.error('Error fetching Discord user:', err);
      throw err;
    }
  },

  getServerNickname: async (accessToken, guildId) => {
    try {
      const response = await fetch(`${DISCORD_API}/users/@me/guilds/${guildId}/member`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      
      if (!response.ok) return null;
      const member = await response.json();
      return member.nick || member.user.username;
    } catch (err) {
      console.error('Error fetching server nickname:', err);
      return null;
    }
  },

  storeToken: (token) => {
    localStorage.setItem('discord_access_token', token);
  },

  getStoredToken: () => {
    return localStorage.getItem('discord_access_token');
  },

  clearToken: () => {
    localStorage.removeItem('discord_access_token');
    localStorage.removeItem('discord_user');
  },

  storeUser: (user) => {
    localStorage.setItem('discord_user', JSON.stringify(user));
  },

  getStoredUser: () => {
    const stored = localStorage.getItem('discord_user');
    return stored ? JSON.parse(stored) : null;
  }
};

function generateState() {
  return Math.random().toString(36).substring(2, 15);
}
